<template>
  <v-card class="pa-4" outlined>

    <v-form ref="formRFC">
      <v-row dense>
        <!-- RFC -->
        <v-col cols="12" md="4">
          <v-text-field label="RFC" v-model="rfc" maxlength="13" @input="onInputRFC" outlined clearable
            dense></v-text-field>
          <!-- Tipo detectado -->
          <v-alert v-if="tipo" type="info" dense class="mt-2">
            Tipo detectado: <strong>{{ tipo }}</strong>
          </v-alert>
        </v-col>
      </v-row>

      <!-- Persona Física -->
      <v-row v-if="tipo === 'Persona Física'" dense>
        <v-col cols="12" md="3">
          <v-text-field label="Nombre" v-model="nombre" outlined dense
            @input="nombre = toUpperCaseGeneral(nombre)"></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field label="Apellido Paterno" v-model="apellidoP" dense
            @input="apellidoP = toUpperCaseGeneral(apellidoP)" outlined></v-text-field>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field label="Apellido Materno" v-model="apellidoM" dense
            @input="apellidoM = toUpperCaseGeneral(apellidoM)" outlined></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>

        <v-col cols="12" md="2">
          <v-text-field label="Código Postal" v-model="codigoPostal" outlined maxlength="5" @input="onInputCP" clearable
            dense></v-text-field>
        </v-col>

      </v-row>
      <!-- Selección de Receptor -->
      <v-row>
        <v-col cols="12" md="6">
          <ReceptorAutocomplete @select="onReceptorSelect" />
        </v-col>

        <v-col cols="3">
          <p><strong>RFC:</strong> {{ receptorSeleccionado?.RFC ?? '' }}</p>

        </v-col>
        <v-col cols="3">
          <v-text-field v-model="claveSAT" label="Clave SAT" outlined dense readonly></v-text-field>
        </v-col>
      </v-row>

      <!-- Selección de Uso CFDI -->
      <v-row>
        <v-col cols="12" md="6" v-if="receptorSeleccionado">
          <UsoCFDISelect :tipo-persona="tipo" @select="usoSeleccionado = $event" />
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import upperCase from '@/mixins/upperCase';
import ReceptorAutocomplete from '@/components/selectReceptorFiscal.vue';
import UsoCFDISelect from '@/components/selectReceptorUsoCFDI.vue';

export default {
  components: { ReceptorAutocomplete, UsoCFDISelect },
  mixins: [upperCase],
  data() {
    return {
      rfc: "CARK931229DZ2",           // siempre preferible inicializar como string
      codigoPostal: null,
      tipo: "",
      nombre: "",
      apellidoP: "",
      apellidoM: "",
      razonSocial: ""
    };
  },
  methods: {
    onInputCP(val) {
      // Solo números y máximo 5 dígitos
      this.codigoPostal = String(val || "").replace(/\D/g, "").slice(0, 5);
    },
    // forzar mayúsculas al escribir (mejor experiencia UX)
    onInputRFC(val) {
      // asegurar que rfc siempre sea string
      this.rfc = String(val || "").toUpperCase();
      this.detectarTipo();
    },

    detectarTipo() {
      // convertir a string por si es null/undefined y luego limpiar
      const clean = String(this.rfc || "").trim().toUpperCase();

      // opcional: eliminar espacios intermedios extras
      // const clean = String(this.rfc || "").replace(/\s+/g, " ").trim().toUpperCase();

      if (!clean) {
        this.tipo = "";
        return;
      }

      if (clean.length === 12) {
        this.tipo = "Persona Moral";
        // limpiar campos irrelevantes
        this.nombre = "";
        this.apellidoP = "";
        this.apellidoM = "";
      } else if (clean.length === 13) {
        this.tipo = "Persona Física";
        this.razonSocial = "";
      } else {
        this.tipo = "";
      }
    }
  }
};
</script>
